<template>
  <div id="app" :class="{
    'font-size-s': fontSize === -1,
    'font-size-xs': fontSize === -2,
    'font-size-l': fontSize === 1,
    'font-size-xl': fontSize === 2,
    'hight-contrast': contrast,
    'dark': dark || contrast,
    'fullscreen': isFullscreen,
    [breakpoint]: breakpoint,
    'loading-data': !dataLoaded
  }">
    <!-- <MainNavigation/> -->
    <div class="pages">
      <transition name="router-anim">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
// import MainNavigation from '@/components/MainNavigation.vue'

export default {
  name: 'museumApp',
  data () {
    return {
      dark: false,
      breakpoints: {
        mobile: 768,
        tablet: 1124,
        large: Infinity
      },
      currentBreakpoint: '',
      loaderTimer: 0,
      loaderDelay: 250
    }
  },
  // components: {
  //   MainNavigation
  // },
  computed: {
    ...mapGetters([
      'mainNavOpen',
      'fontSize',
      'contrast',
      'breakpoint',
      'apiPath',
      'isFullscreen',
      'dataLoaded'
    ])
  },
  methods: {
    ...mapActions([
      'setBreakpoint',
      'setWindowWidth',
      'getMainResponse',
      'openPageNav',
      'closePageNav',
      'setDataLoaded'
    ]),
    handleResize () {
      const clientWidth = window.innerWidth
      if (clientWidth < this.breakpoints.mobile) {
        this.currentBreakpoint = 'mobile'
        this.closePageNav()
      } else if (clientWidth < this.breakpoints.tablet) {
        this.currentBreakpoint = 'tablet'
        this.closePageNav()
      } else if (clientWidth <= this.breakpoints.large) {
        this.currentBreakpoint = 'large'
        // this.openPageNav()
      }

      if (this.breakpoint !== this.currentBreakpoint) {
        this.setBreakpoint(this.currentBreakpoint)
      }

      this.setWindowWidth(clientWidth)
    },
    fullscreenChangeHandler () {
      if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) {
        this.$store.state.isFullscreen = true
      } else {
        this.$store.state.isFullscreen = false
        this.$store.state.iframeFullscreen = false
      }
    },
    getData () {
      clearTimeout(this.loaderTimer)
      this.loaderTimer = setTimeout(this.setDataLoaded, this.loaderDelay, false)

      axios.get(`${this.apiPath}main`)
        .then(response => {
          if (typeof response.data === 'object') {
            clearTimeout(this.loaderTimer)
            this.getMainResponse(response.data)
            this.setDataLoaded(true)
          } else {
            this.setDataLoaded(false)
          }
        })
        .catch(e => {
          console.error(e)
          this.setDataLoaded(false)
        })
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    document.addEventListener('webkitfullscreenchange', this.fullscreenChangeHandler, false)
    document.addEventListener('mozfullscreenchange', this.fullscreenChangeHandler, false)
    document.addEventListener('fullscreenchange', this.fullscreenChangeHandler, false)
    document.addEventListener('MSFullscreenChange', this.fullscreenChangeHandler, false)
    this.handleResize()
    window.requestAnimFrame = (function () {
      return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60)
      }
    })()
  },
  watch: {
    apiPath (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getData()
      }
    }
  },
  created () {
    this.getData()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss">
@import './assets/scss/fonts';
@import './assets/scss/_partials/layout';
@import './assets/scss/_partials/form-items';
@import './assets/scss/_partials/content-toggle';
@import './assets/scss/_partials/downloads';

@import './assets/scss/_partials/hight-contrast';
@import './assets/scss/_partials/animations';
</style>
